import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {
    ApiError,
    ApiResponse,
    HttpStatusCodesEnum,
    DocumentTypesEnum,
    DocumentStatusTriggersEnum,
    IndividualDocumentsService,
    IndividualDocumentModel,
    IndividualDocumentStatusTriggerModel
} from '@spa/api';

import {Helper} from '../../../../shared/classes';
import {SelectOptionInterface} from '../../../../shared/components/select';
import {BaseControl, SelectControl} from '../../../../shared/classes/controls';

import {AddDocumentFormErrorStatesEnum} from '../../enums';

import {
    AddDocumentControls,
    AddDocumentSubTypeSelector,
    AddDocumentTypeSelector
} from '../../../../../assets/descriptors';

export class AddDocumentTrait {
    private constructor() {
    }

    static initControls(documentType: string, corporateDocuments: boolean): BaseControl[] {
        return AddDocumentControls().map((control: BaseControl) => {
            switch (control.name) {
                case AddDocumentTypeSelector:
                    control.value = documentType;

                    let typeKeys = null;

                    if (!corporateDocuments) {
                        typeKeys = Helper.enumsHelper().getDocumentTypes().getTypeKeys();


                        (control as SelectControl).options = typeKeys.map((key: string) => {
                            return {
                                label: Helper.enumsHelper().getDocumentTypes().getTypeValue(key),
                                value: key
                            };
                        });
                    } else {
                        typeKeys = Helper.enumsHelper().getCompanyDocumentTypes().getTypeKeys();

                        (control as SelectControl).options = typeKeys.map((key: string) => {
                            return {
                                label: Helper.enumsHelper().getCompanyDocumentTypes().getTypeValue(key),
                                value: key
                            };
                        });

                        const proofOAddressOption: SelectOptionInterface = {
                            label: Helper.enumsHelper().getDocumentTypes().getTypeValue(DocumentTypesEnum.ProofOfAddress),
                            value: DocumentTypesEnum.ProofOfAddress
                        };

                        const otherDocumentsOption: SelectOptionInterface = {
                            label: Helper.enumsHelper().getDocumentTypes().getTypeValue(DocumentTypesEnum.Other),
                            value: DocumentTypesEnum.Other
                        };

                        (control as SelectControl).options.push(proofOAddressOption, otherDocumentsOption);
                    }
                    break;
                case AddDocumentSubTypeSelector:
                    let lookup = null;

                    switch (documentType) {
                        case DocumentTypesEnum.ProofOfAddress:
                            lookup = Helper.enumsHelper().getProofOfAddressDocumentTypes();
                            break;
                        case DocumentTypesEnum.ProofOfIdentity:
                            lookup = Helper.enumsHelper().getProofOfIdentityDocumentTypes();

                    }

                    if (lookup) {
                        (control as SelectControl).options = lookup.getTypeKeys().map((key: string) => {
                            return {
                                label: lookup.getTypeValue(key),
                                value: key
                            };
                        });
                    }
                    break;
            }

            return control;
        });
    }

    static changeDocumentStatus(
        documentsService: IndividualDocumentsService,
        registrationResponse: ApiResponse<ApiError[] | IndividualDocumentModel>
    ): Observable<ApiResponse<ApiError[] | IndividualDocumentModel>> {
        if (registrationResponse.status !== HttpStatusCodesEnum.Ok) {
            return Helper.errorsHelper().createErrorResponseObservable<IndividualDocumentModel>(
                registrationResponse
            );
        }

        const individualDocumentModel = registrationResponse.data as IndividualDocumentModel;

        const individualDocumentStatusInputModel = new IndividualDocumentStatusTriggerModel(
            individualDocumentModel.id,
            DocumentStatusTriggersEnum.InReview
        );

        return documentsService.changeStatus(individualDocumentStatusInputModel)
            .pipe(
                map((statusResponse: ApiResponse<ApiError[] | null>) => {
                    if (statusResponse.status !== HttpStatusCodesEnum.Ok) {
                        return Helper.errorsHelper().createErrorResponse<null>(
                            statusResponse,
                            AddDocumentFormErrorStatesEnum.UpdateDocumentToInReviewFailed
                        );
                    }

                    individualDocumentModel.status = Helper.enumsHelper().getDocumentStatusByTrigger(
                        DocumentStatusTriggersEnum.InReview
                    );

                    return Helper.createSuccessResponse<IndividualDocumentModel>(individualDocumentModel);

                })
            );
    }
}
